var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBracketsSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 48H136C140.406 48 144 44.422 144 40S140.406 32 136 32H56C33.938 32 16 49.938 16 72V440C16 462.062 33.938 480 56 480H136C140.406 480 144 476.422 144 472S140.406 464 136 464H56C42.781 464 32 453.234 32 440V72C32 58.766 42.781 48 56 48ZM392 32H312C307.594 32 304 35.578 304 40S307.594 48 312 48H392C405.219 48 416 58.766 416 72V440C416 453.234 405.219 464 392 464H312C307.594 464 304 467.578 304 472S307.594 480 312 480H392C414.062 480 432 462.062 432 440V72C432 49.938 414.062 32 392 32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBracketsSquare);
export default __webpack_public_path__ + "static/media/brackets-square.f5ea80949014e58e29201565686b88cf.svg";
export { ForwardRef as ReactComponent };